module.exports = __webpack_public_path__ + "img/25.e1fd7d0a.jpg";